<template>
  <v-card class="mx-auto" max-width="650" flat>
    <v-card-text>
      <v-row>
        <v-col cols="2" sm="1">
          <v-avatar :color="randomColor" size="40">
            <img v-if="isAvatar" :src="avatarPath" alt="picture" />
            <span v-else class="_light_grey--text headline">{{ photoWord }}</span>
          </v-avatar>
        </v-col>
        <v-col cols="10" sm="11">
          <v-row justify="space-between">
            <v-col cols="auto">
              <div class="ml-1 text-subtitle-1 font-weight-black">{{ data.userName }}</div>
              <v-row align="center" class="mx-0 pt-2">
                <v-rating v-model="data.rating" color="_grey" background-color="_grey" dense half-increments readonly size="14"></v-rating>
                <span class="ml-1">{{ new Date(data.updateTime).toLocaleDateString() }}</span>
              </v-row>
            </v-col>
            <v-col cols="auto" align="center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon style="outline: none" @click="helpfulHandler()">
                    <v-icon v-bind="attrs" v-on="on" :color="helpfulIconColor" dense>mdi-thumb-up</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('helpful') }}</span>
              </v-tooltip>
              <v-menu bottom right offset-y>
                <template v-slot:activator="{ on: menu, attrs }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on: tooltip }">
                      <v-icon v-bind="attrs" v-on="{ ...tooltip, ...menu }">mdi-dots-vertical</v-icon>
                    </template>
                    <span>{{ $t('moreOptions') }}</span>
                  </v-tooltip>
                </template>
                <v-list>
                  <v-list-item v-for="item in options" :key="item" @click="menuHandler(item)">
                    <v-list-item-title>{{ $t(item) }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-row justify="center">
                <span class="mr-7">{{ data.helpful }}</span>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col>{{ data.comment }}</v-col>
          </v-row>
          <v-row v-if="data.hasOwnProperty('response')">
            <v-card class="_light_grey" width="580" flat>
              <v-card-text>
                <div>
                  <span class="text-body-2 font-weight-black">{{ data.response.userName }}</span>
                  {{ new Date(data.response.updateTime).toLocaleDateString() }}
                </div>
                {{ data.response.comment }}
              </v-card-text>
            </v-card>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import CommVar from '@/method/commVar';

export default {
  name: 'Comment',
  props: {
    data: { type: Object, default: () => ({ userName: '' }) },
    options: { type: Array, default: () => ['edit', 'helpless'] },
  },
  data: () => ({
    randomColor: `rgb( ${Math.floor(CommVar.random() * 256)}, ${Math.floor(CommVar.random() * 256)}, ${Math.floor(CommVar.random() * 256)})`,
    helpfulIconColor: '_grey',
    isActive: false,
  }),
  computed: {
    photoWord() {
      return this.data.userName[0];
    },
    isAvatar() {
      return Object.prototype.hasOwnProperty.call(this.data, 'avatar');
    },
    avatarPath() {
      return `${process.env.VUE_APP_S3_URL}public/avatar/${this.data.avatar}`;
    },
  },
  methods: {
    // editHandler() {
    //   this.isEdit = true;
    // },
    helpfulHandler() {
      if (this.helpfulIconColor === '_blue') return;
      this.data.helpful += 1;
      this.helpfulIconColor = '_blue';
      this.$emit('helpful');
    },
    menuHandler(item) {
      switch (item) {
        case 'edit':
        case 'response':
          this.$emit(item);
          break;
        case 'helpless':
          if (this.helpfulIconColor === '_grey' && this.isActive) break;
          this.isActive = true;
          this.data.helpful = this.data.helpful - 1 < 0 ? 0 : this.data.helpful - 1;
          this.helpfulIconColor = '_grey';
          this.$emit('helpful');
          break;
        default:
          break;
      }
    },
  },
};
</script>
